var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875.5h-9.75C.504.5 0 1.004 0 1.625v6.75C0 8.996.504 9.5 1.125 9.5h9.75C11.496 9.5 12 8.996 12 8.375v-6.75C12 1.004 11.496.5 10.875.5zm.375 7.875a.375.375 0 01-.375.375h-9.75a.375.375 0 01-.375-.375v-6.75c0-.207.168-.375.375-.375h9.75c.207 0 .375.168.375.375v6.75zM2.625 4.437a1.313 1.313 0 100-2.625 1.313 1.313 0 000 2.625zm0-1.875a.563.563 0 11-.001 1.127.563.563 0 01.001-1.127zm4.852.54L5.25 5.33l-.727-.728a.562.562 0 00-.796 0L1.665 6.665a.562.562 0 00-.165.397v.657c0 .155.126.281.281.281h8.438a.281.281 0 00.281-.281V5.562c0-.149-.06-.292-.165-.397L8.273 3.102a.563.563 0 00-.796 0zM9.75 7.25h-7.5v-.11l1.875-1.875L5.25 6.39l2.625-2.625L9.75 5.64v1.61z",
    fill: "#3454EF"
  })));
}

export default __webpack_public_path__ + "./fonts/image-icon-blue.b553f6f95b4fa27df9bfae63f3a2bcae.svg";
export { SvgImageIconBlue as ReactComponent };